import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '@env/environment'
import { Observable } from 'rxjs'

@Injectable()
export class WardsService {
  constructor(private http: HttpClient) {}

  public fetchWards(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/ward/list`
    return this.http.post(url, params)
  }
  public fetchWard(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/ward/${id}`
    return this.http.get(url, {})
  }

  public deleteWard(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/ward/${id}`
    return this.http.delete(url)
  }

  public createWard(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/ward`
    return this.http.post(url, params)
  }

  public updateWard(id: number, params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/ward/${id}`
    return this.http.put(url, params)
  }
}
